// select units quantity block

const productQuantityRetailItems = document.querySelectorAll('.product-quantity-retail-item')
productQuantityRetailItems.forEach((item) => {
    item.addEventListener('click', (e) => {
        if(!item.classList.contains('active')){
            productQuantityRetailItems.forEach((el) => {
                el.classList.remove('active')
            })
            item.classList.add('active')
            if (typeof setStickyButton === "function") {
                setStickyButton(item)
            }
        }
    })
})


// select retail / bulk mode

const productQuantitySelection = document.querySelector('.product-quantity-selection')
const productSetBulkButton = document.querySelector('.product-quantity-set-bulk')
const productSetretailButton = document.querySelector('.product-quantity-set-retail')
const productRetail = document.querySelector('.product-quantity-retail')
const productBulk = document.querySelector('.product-quantity-bulk')
productSetBulkButton.addEventListener('click', (e) => {
    $(productRetail).slideUp()
    $(productBulk).slideDown()
    productQuantitySelection.classList.add('bulk')
    if (typeof setStickyButtonMode === "function") {
        setStickyButtonMode('bulk')
    }
})
productSetretailButton.addEventListener('click', (e) => {
    $(productRetail).slideDown()
    $(productBulk).slideUp()
    productQuantitySelection.classList.remove('bulk')
    if (typeof setStickyButtonMode === "function") {
        setStickyButtonMode('retail')
    }
})



// whats-in-the-box pop-up

// const wibButton = document.querySelector('.product-whats-in-the-box-button')
// const wibPopup = document.querySelector('.product-whats-in-the-box-popup')
// wibButton.addEventListener('click', (e) => {
//     wibPopup.classList.toggle('open')
// })

// document.addEventListener('click', (e) => {
//     if( e.target != wibButton && !e.target.closest('.product-whats-in-the-box-popup') ){ 
//         wibPopup.classList.remove('open')
//     }
// })


// select product-color-variation
const productColorVariationSelectorItem = document.querySelectorAll('.product-color-variation-item')
productColorVariationSelectorItem.forEach((el) => {
    el.addEventListener('click', (e) => {
        if(!el.classList.contains('active')){
            el.parentNode.querySelector('.product-color-variation-item.active').classList.remove('active')
            el.classList.add('active')
            productChangeColorVariationImage(el)
        }
    })
})

function productChangeColorVariationImage(el){
    let curQuantitySelected = document.querySelector('.product-quantity-retail-item.active')
    if(!curQuantitySelected){
        return
    }
    let image = curQuantitySelected.querySelector('.product-quantity-retail-item-image img')
    let qt = curQuantitySelected.dataset.productQuantity
    if( qt > 3 ){
        qt = 3
    }

    let colorSet = []
    let activeColors = curQuantitySelected.querySelectorAll('.product-color-variation-item.active')
    activeColors.forEach((item) => {
        colorSet.push(item.dataset.variationColor)
    })
    let clolors = colorSet.sort().join('-')
    let img_url = getImageUrl('product-luminette-3' + '-' + clolors + '-qt-' + qt + '-' + '2x')
    changeProductImage(image, img_url)
    if (typeof setStickyButtonImage === "function") {
        setStickyButtonImage(img_url)
    }
    
}









const productBulkQtMinusButtons = document.querySelectorAll('.product-quantity-bulk-minus')
const productBulkQtPlusButtons = document.querySelectorAll('.product-quantity-bulk-plus')
const productBulkInputs = document.querySelectorAll('.product-quantity-bulk-input')
const productQuantityBulkUnitsCount = document.querySelector('.product-quantity-bulk-units-qt')
const productQuantityBulkUnitsDiscountBadge = document.querySelector('.product-quantity-bulk-units-discount-badge')
const productQuantityBulkItemPrice = document.querySelector('.product-quantity-bulk-item-price')
const productQuantityBulkUnitPriceValue = document.querySelector('.product-quantity-bulk-unit-price-value')
const productQuantityBulkUnitPriceValueOriginal = document.querySelector('.product-quantity-bulk-unit-price-per-unit-original')
const productQuantityBulkBadgeProfit = document.querySelector('.product-quantity-bulk-badge-profit')

let bulkUnitsTotalQuantity = 4

productBulkQtMinusButtons.forEach((item) => {
    item.addEventListener('click', (e) => {
        let container = item.parentElement
        let inputEl = container.querySelector('input')
        let inputValue = parseInt(inputEl.value)
        if( inputValue > 0 && bulkUnitsTotalQuantity > 4 ){
            inputValue--
            bulkUnitsTotalQuantity--
            inputEl.value = inputValue
        }
        if( inputValue == 0 || bulkUnitsTotalQuantity <= 4){
            item.disabled = true
        }
        if(bulkUnitsTotalQuantity <= 4){
            productBulkInputs.forEach((bulkInput) => {
                bulkInput.previousElementSibling.disabled = true
            })
        }
        if( inputValue == 0 ){
            let color = inputEl.name
            let indicatorClassName = '.product-quantity-bulk-discount-selector-color.'+color
            let indicatorObj = document.querySelector(indicatorClassName)
            if(indicatorObj){
                indicatorObj.classList.remove('active')
            }
        }
        
        setProductQuantityBulk()
    })
})


productBulkQtPlusButtons.forEach((item) => {
    item.addEventListener('click', (e) => {
        let container = item.parentElement
        let inputEl = container.querySelector('input')
        let minusButton = container.querySelector('.product-quantity-bulk-minus')
        let inputValue = parseInt(inputEl.value) + 1
        bulkUnitsTotalQuantity++
        inputEl.value = inputValue
        if(bulkUnitsTotalQuantity > 4){
            productBulkInputs.forEach((bulkInput) => {
                if(bulkInput.value > 0){
                    bulkInput.previousElementSibling.disabled = false
                }
            })
        }
        let color = inputEl.name
        let indicatorClassName = '.product-quantity-bulk-discount-selector-color.'+color
        let indicatorObj = document.querySelector(indicatorClassName)
        if(indicatorObj){
            indicatorObj.classList.add('active')
        }
        
        setProductQuantityBulk()
    })        
})

function setProductQuantityBulk(){
    quantity = 0
    productBulkInputs.forEach((bulkInput) => {
        quantity += parseInt(bulkInput.value)
    })
    productQuantityBulkUnitsCount.innerHTML = quantity

    let curDiscountAmount = null
    if(quantity <= 24){
        curDiscountAmount = productDiscountAmounts[quantity]
    }else{
        curDiscountAmount = productDiscountAmounts[24]
    }

    productQuantityBulkUnitsDiscountBadge.innerHTML = '-'+curDiscountAmount+'%'
    let basePrice = parseInt(productQuantityBulkItemPrice.dataset.basePrice)
    let pricePerUnit = parseInt( basePrice * ( 100 - curDiscountAmount ) / 100 )
    let priceTotal = parseInt( basePrice * quantity * ( 100 - curDiscountAmount ) / 100 )
    productQuantityBulkItemPrice.innerHTML = getPromotionalPrice(priceTotal).toFixed()
    productQuantityBulkUnitPriceValue.innerHTML = getPromotionalPrice(pricePerUnit).toFixed()
    if(productQuantityBulkUnitPriceValueOriginal){
        productQuantityBulkUnitPriceValueOriginal.innerHTML = priceTotal.toFixed()
    }

    let profit = basePrice * quantity - priceTotal
    productQuantityBulkBadgeProfit.innerHTML = profit

    if (typeof setStickyButtonBulk === "function") {
        setStickyButtonBulk()
    }
}










const productAddToCartButtons = document.querySelectorAll('.product-item-add-to-cart')
productAddToCartButtons.forEach((productAddToCartButton) => {
    productAddToCartButton.addEventListener('click', (e) => {
        let currentProductEl = document.getElementById('product-luminette-3')
        const cartSidebar = document.getElementById('cart-sidebar')
        //const l3BulkInput = document.getElementById('luminette-3-bulk-variation')
        if( currentProductEl !== null ){
            addProduct(currentProductEl)
            cartSidebar.classList.add('step-2')
            let productQuantity = 1
            if(productQuantitySelection.classList.contains('bulk')){
                //productQuantity = productQuantityBulkInput.value
                //l3BulkInput.value = productQuantity
                productQuantity = 0
                productBulkInputs.forEach((bulkInput) => {
                    let curVariationQt = parseInt(bulkInput.value)
                    productQuantity += curVariationQt

                    let curVariationColor = bulkInput.name
                    let cartInputID = '#luminette-3-bulk-variation-'+curVariationColor
                    let cartInputObj = currentProductEl.querySelector(cartInputID)
                    let colorIndicatorClass = '.color-indicator.'+curVariationColor
                    let colorIndicatorObj = currentProductEl.querySelector(colorIndicatorClass)
                    if(curVariationQt > 0){
                        cartInputObj.value = curVariationQt
                        colorIndicatorObj.classList.remove('disabled')
                    }else{
                        cartInputObj.value = 0
                        colorIndicatorObj.classList.add('disabled')
                    }
                })

                setBulkMode(currentProductEl, true)
                bulkImageVariant(currentProductEl)
                setUnitsQuantity()
                
            }else{
                setBulkMode(currentProductEl, false)
                let selectedVariationObj = document.querySelector('.product-quantity-retail-item.active')
                let selectedVariationQuantity = selectedVariationObj.dataset.productQuantity
                
                let colorVariations = selectedVariationObj.querySelectorAll('.product-color-variation')
                
                let cartVariantClass = '.item-variation[data-quantity="'+selectedVariationQuantity+'"]'
                let cartVariantObj = currentProductEl.querySelector(cartVariantClass)
                currentProductEl.querySelector('.item-variation.active').classList.remove('active')
                cartVariantObj.classList.add('active')
                let cartColors = cartVariantObj.querySelectorAll('.item-variation-item-colors')
                let colorSet = []
                colorVariations.forEach((variation, i) => {
                    let activeVariation = variation.querySelector('.product-color-variation-item.active')
                    let activeColor = activeVariation.dataset.variationColor
                    colorSet.push(activeColor)
                    cartColors[i].querySelector('[data-color="'+activeColor+'"]').checked = true
                })
                
                let clolors = colorSet.sort().join('-')
                let img_url = getImageUrl('product-luminette-3' + '-' + clolors + '-qt-' + selectedVariationQuantity + '-' + '2x')
                let image = currentProductEl.querySelector('.in-cart-item-head-image img')
                changeProductImage(image, img_url)
                
                setUnitsQuantity()
                
            }

            //toggleMinimized(currentProductEl, false)
            //changeColorVariationImage(currentProductEl)
            
            saveState()
            discounts()
            
            
            window.setTimeout(function(){
                document.body.classList.add('sidebar-open')
            }, 200);

            if(productAddToCartButton.classList.contains('sticky-button-el')){
                e.stopPropagation()
            }
        }
    })
})




// Routine Image

const l3RoutineImage = document.querySelector('.l3-routine-image')
const l3RoutineButtons = document.querySelectorAll('.l3-routine-select')
const l3RoutineWrp = document.querySelector('.product-luminette-3-routine-image')
if(l3RoutineButtons){
    l3RoutineButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            l3RoutineWrp.classList.add('paused')
            l3RoutinePause()
            let imageID = button.dataset.image
            selectl3Routine(imageID)
        })
    })

    function l3RoutinePause(){
        setTimeout(function(){
            l3RoutineWrp.classList.remove('paused');
        }, 2000)
    }

    setInterval(() => {
        if(  !l3RoutineWrp.classList.contains('paused') ){ // !l3RoutineImage.matches(':hover')
            let buttons = document.querySelectorAll('.l3-routine-select')
            let curButton = document.querySelector('.l3-routine-select.active')
            let curImageID = curButton.dataset.image
            let curIndex = curImageID.substring( curImageID.length - 1)

            if( curIndex == 1  ){
                curIndex = buttons.length
            }else{
                curIndex--
            }
            selectl3Routine('l3-routine-image-'+curIndex)
        }
    }, 2500)
}



function selectl3Routine(imageID){
    let imageEl = document.getElementById(imageID)
    if(imageEl){
        let down = document.querySelectorAll('.l3-routine-select.down')
        if(down){
            down.forEach((downEl) => {
                downEl.classList.remove('down')
            })
        }
        document.querySelector('.l3-routine-image-item.active').classList.remove('active')
        document.querySelector('.l3-routine-select.active').classList.remove('active')
        imageEl.classList.add('active')
        let button = document.querySelector('.l3-routine-select[data-image="'+imageID+'"]')
        if(button){
            button.classList.add('active')
        }
        let hiddenData = button.dataset.hideOn
        if(hiddenData){
            let hiddenArray = JSON.parse(hiddenData)
            if(hiddenArray){
                hiddenArray.forEach((i) => {
                    //console.log(l3RoutineButtons[ i - 1 ]);
                    l3RoutineButtons[ i - 1 ].classList.add('down')
                })
            }
        }
    }
}



// popup Zoom

const popupZoomInner = document.querySelector('.popup-zoom-inner img')
if(popupZoomInner){
    let aspect = 1
    let imageWidth
    let windowWidth
    popupStarter = document.querySelector('.l3-wib-image-wrp-mobile')
    popupStarter.addEventListener('click', (e) => {
        imageWidth = popupZoomInner.getBoundingClientRect().width
        windowWidth = window.innerWidth
    })
    
    let clientX;
    let clientY;
    popupZoomInner.addEventListener("touchstart", (e) => {
            clientX = e.touches[0].clientX;
            clientY = e.touches[0].clientY;
    }, false, );
    
    popupZoomInner.addEventListener('touchmove', function (e) {
        let deltaX = e.changedTouches[0].clientX - clientX;
        let style = window.getComputedStyle(popupZoomInner)
        let transform = new WebKitCSSMatrix(style.transform).m41
        let newTransform = transform + deltaX * aspect
        if( Math.abs( newTransform ) < (imageWidth - windowWidth) / 2 ){
            popupZoomInner.style.transform = "translateX(" + newTransform + "px)";    
        }
        
    })
   
}


// show more

$("#show-more-section").click(function(){
    $(".show-more-wrp").slideDown('fast');
    $(".show-more-button-wrp").slideUp('fast');
});



// video clip

const luminette3videoclip = document.getElementById('product-luminette-3-videoclip-video');
const videoOffset = 300;

document.addEventListener('DOMContentLoaded', () => {
    setVideoSrc();
});

window.addEventListener("resize", resizeThrottler, false);

var resizeTimeout;
function resizeThrottler() {
    if ( !resizeTimeout ) {
        resizeTimeout = setTimeout(function() {
            resizeTimeout = null;
            setVideoSrc();
        }, 500);
    }
}

if(luminette3videoclip){
    luminette3videoclip.addEventListener('click', (e) => {
        if(!luminette3videoclip.classList.contains('paused')){
            luminette3videoclip.classList.add('paused')
            luminette3videoclip.pause()
        }else{
            luminette3videoclip.classList.remove('paused')
            luminette3videoclip.play()
        }
    });

    let luminette3videoclipDescription1 = document.getElementById('product-luminette-3-videoclip-description-1');
    let luminette3videoclipDescription2 = document.getElementById('product-luminette-3-videoclip-description-2');
    let luminette3videoclipDescription1Spans = luminette3videoclipDescription1.querySelectorAll('span');
    let luminette3videoclipDescription2Spans = luminette3videoclipDescription2.querySelectorAll('span');
    let timeToChangeInCar = 5;
    let bounceInterval = 150;
    luminette3videoclip.addEventListener("timeupdate", (event) => {
        if(!luminette3videoclip.paused){
            if(luminette3videoclip.currentTime > timeToChangeInCar ){
                luminette3videoclipDescription1.classList.remove('active');
                luminette3videoclipDescription2.classList.add('active');
                luminette3videoclipDescription1Spans.forEach( el => el.classList.remove('bounce-up') );
                luminette3videoclipDescription2Spans.forEach(function (item, index) {
                    setTimeout(function () {
                        item.classList.add('bounce-up');
                    }, index * bounceInterval);
                });
            }else{
                luminette3videoclipDescription1.classList.add('active');
                luminette3videoclipDescription2.classList.remove('active');
                luminette3videoclipDescription2Spans.forEach( el => el.classList.remove('bounce-up') );
                luminette3videoclipDescription1Spans.forEach(function (item, index) {
                    setTimeout(function () {
                        item.classList.add('bounce-up');
                    }, index * bounceInterval);
                });
            }
        }
    });

    document.addEventListener("scroll", (e)=>{
        if(iSinViewport(luminette3videoclip, videoOffset)){
            if(!luminette3videoclip.classList.contains('paused') && luminette3videoclip.paused){
                luminette3videoclip.play();
            }
        }
    });
}


const iSinViewport = (elem, offset = 0) => {
    let windowHeight = window.innerHeight;
    let viewportOffset = elem.getBoundingClientRect(); 
    let top = viewportOffset.top + offset; 
    let btm = viewportOffset.bottom - offset; 
    
    if(top < windowHeight){ 
        return true;
    } else{
        return false;
    }
}

function setVideoSrc(){
    let mobileWidth = 480;
    const videos = document.querySelectorAll('video')
    if(videos){
        videos.forEach((video) => {
            let mobileSrc = video.dataset.mobileSrc
            let desktopSrc = video.dataset.desktopSrc
            //let posterDesktop = video.dataset.posterDesktop
            //let posterMobile = video.dataset.posterMobile
            if(mobileSrc !== undefined && desktopSrc !== undefined){
                if( window.innerWidth <= mobileWidth && !video.classList.contains('video-mobile') ){
                    // mobile
                    video.pause();
                    video.src = mobileSrc;
                    //video.poster = posterMobile;
                    if(iSinViewport(video, videoOffset)){
                        video.play();
                    }
                    video.classList.remove('video-desktop');
                    video.classList.add('video-mobile');
                    console.log('set to mobile');
                    return;
                }
                if( window.innerWidth > mobileWidth && !video.classList.contains('video-desktop') ){
                    // desktop
                    video.pause();
                    video.src = desktopSrc;
                    //video.poster = posterDesktop;
                    if(iSinViewport(video, videoOffset)){
                        video.play();
                    }
                    video.classList.remove('video-mobile');
                    video.classList.add('video-desktop');
                    console.log('set to desktop');
                }
            }
        })
    }
}